import { authorizedFetch } from './httpClient';

const API_URL = process.env.REACT_APP_API_URL;

export interface OrganizationEntry {
  id: string;
  name: string;
  createdAt: string;
}

export interface PaginatedResponse<T> {
  rows: T[];
  totalElements: number;
  totalPages: number;
  page: number;
  size: number;
}

export const getOrganizations = async (): Promise<PaginatedResponse<OrganizationEntry>> => {
  const response = await authorizedFetch(`${API_URL}/api/organizations`);
  if (!response.ok) throw new Error('Failed to fetch organizations');
  return response.json();
};

export interface CreateOrganizationRequest {
  name: string;
}

export type OrganizationViolationField = 'NAME';
export type OrganizationViolationReason = 'EMPTY' | 'TOO_LONG' | 'TOO_SHORT';

export interface CreateOrganizationViolation {
  violation: string;
  details: { field: OrganizationViolationField; reason: OrganizationViolationReason };
}

export interface CreateOrganizationResult {
  isSuccess: boolean;
  success: { id: string } | null;
  error: { violations: CreateOrganizationViolation[] } | null;
}

export const createOrganization = async (request: CreateOrganizationRequest): Promise<CreateOrganizationResult> => {
  const response = await authorizedFetch(`${API_URL}/api/organizations`, {
    method: 'POST',
    body: JSON.stringify(request),
  });
  if (response.ok) {
    const success = await response.json() as { id: string };
    return { isSuccess: true, success, error: null };
  }
  const error = await response.json() as { violations: CreateOrganizationViolation[] };
  return { isSuccess: false, success: null, error };
};
